namespace $.$$ {

	$mol_style_define( $shm_dashboard_admin_auth, {

		Body_content: {
			padding: 0,
		},

		Login_form: {
			flexDirection: 'column',
			gap: $mol_gap.block,
		},

		Dashboard: {
			width: '100%',
		},

		Email: {
			width: '100%',
		},

		Password: {
			width: '100%',
		},

		Submit: {
			width: '10rem',
			margin: {
				top: $mol_gap.block,
			},
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
				self: 'center',
			},
		},

		Message: {
			color: $mol_theme.shade,
			userSelect: 'text',
		},

		Session: {
			flexDirection: 'column',
			gap: $mol_gap.block,
			userSelect: 'text',
		},

		Current_user: {
			color: $mol_theme.current,
			userSelect: 'text',
		},

		Logout: {
			width: '10rem',
			justify: {
				content: 'center',
			},
			align: {
				items: 'center',
			},
		},
	} )

}
